import { createSelector } from '@reduxjs/toolkit'

import { ApplicationState } from 'redux/Stores/types'
import { StatusBannerReducerType } from 'redux/reducers/StatusBanner'

export const selectStatusBanners = createSelector(
  [
    (state: ApplicationState): StatusBannerReducerType =>
      state.StatusBannerStore
  ],
  (store) => store.data
)
